/* eslint-disable @typescript-eslint/class-name-casing */
import * as React from 'react'
import styled from 'styled-components'
import {
  commonProps,
  CommonProps,
  flexContainerProps,
  FlexContainerProps,
  typographyProps,
  TypographyProps,
  compose,
  sx,
  SxProps
} from '@bestyled/system'
import { useDefaultTextStyles } from './DefaultTextStyle'
import { filterViewProps } from '../util/filterViewProps'

export interface TextProps
  extends CommonProps,
    TypographyProps,
    FlexContainerProps,
    SxProps {
  is?: string
  style?: any
  itemType?: string
}

const CleanTag = (props) => {
  return React.createElement(props.is || 'span', filterViewProps(props))
}

export const StyledText = styled(CleanTag)(
  compose(commonProps, typographyProps, flexContainerProps),
  sx
) as React.FC<TextProps>

export const Text: React.FC<TextProps> = (props) => {
  const defaults = useDefaultTextStyles()

  const propsWithDefaults = React.useMemo(() => ({ ...defaults, ...props }), [
    props,
    defaults
  ])

  return <StyledText {...propsWithDefaults} />
}

Text.defaultProps = { itemType: 'Text' }

Text.displayName = 'Text'
